// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"48":"laboratory","353":"contact","417":"setting","857":"report","899":"payment","962":"home","964":"product"}[chunkId] + "." + {"48":"d6e3ad45","353":"37c0fab7","417":"86c659c1","857":"4574cd08","899":"a8f9f611","962":"7d761446","964":"8e1edff9"}[chunkId] + ".js";
};